import { gql } from '../types/generated';

export const UPDATE_PIPELINE_CONFIG = gql(`
  mutation updatePipelineConfig($teamId: Int!, $region: Region, $pipelineConfig: PipelineConfig!) {
    updatePipelineConfig(teamId: $teamId, region: $region, pipelineConfig: $pipelineConfig) {
      ...PipelineConfigFields
    }
  }
`);
